import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const trackedServiceTemplateEntityAdapter: EntityAdapter = {
  entity: "trackedServiceTemplate",
  convertsPriceToEurocent: false,
  rowBackgroundColor: (row) => (row.original.override_applied ? "#d6bce9" : undefined),
};
